import React, { useEffect, useState } from 'react';
import Navbar from '../../components/Header';
import axios from 'axios';
import Content from '../../components/DetailArea/Content';
import Footer from '../../components/Footer';
import HeroSection from '../../components/DetailArea/HeroSection';

function UpcomingPropertiesPage() {
  let [data, setData] = useState([]);
  let [filterData, setFilterData] = useState([]);
  const [searchResult, setSearchResult] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    async function getData() {
      await axios
        .get(`${process.env.REACT_APP_API_URL}/api/properties?status=offPlan`)
        .then((response) => {
          setData(
            response.data.filter((property) => {
              console.log(property);
              return property.status === 'approved';
            })
          );
        })
        .catch((error) => {
          console.error('Error:', error);
        });
    }
    getData();
  }, []);

  function handleFilter(searchResult) {
    setFilterData(data);
    if (searchResult.city !== 'Dubai') {
      setFilterData((prev) => {
        return prev.filter((property) =>
          property.location.includes(searchResult.city)
        );
      });
    }
    if (searchResult.propertyType !== 'Any') {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return property.propertyType === searchResult.propertyType;
        });
      });
    }
    if (searchResult.price !== 'Any') {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return parseInt(property.price) > parseInt(searchResult.price);
        });
      });
    }
    if (searchResult.complete !== 'Any') {
      setFilterData((prev) => {
        return prev.filter((property) => {
          return property.propertyStatus === searchResult.complete;
        });
      });
    }
  }

  return (
    <div>
      <Navbar />
      <HeroSection
        location={'Upcoming Properties'}
        searchResult={searchResult}
        setSearchResult={setSearchResult}
        handleFilter={handleFilter}
      />
      <Content data={data} />
      <Footer />
    </div>
  );
}

export default UpcomingPropertiesPage;
